import styled from 'styled-components';

import LinkWithStore from 'ggApp/modules/router/components/linkWithStore';

export const BackToCartLink = styled(LinkWithStore)`
    margin-top: 8px;
    margin-bottom: 8px;
    display: inline-block;
`;
